var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-item",class:{ 'active': _vm.isActive },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.title)+" "),(_vm.count !== null)?_c('span',[_vm._v(_vm._s(_vm.count))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }